var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -2048 2055 2048",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "scale(1, -1)",
    d: "M1115 2048l549 -549v-91h-640v640h91zM1152 1536h293l-293 293v-293zM1536 1152v128h128v-128h-128zM1536 896v128h128v-128h-128zM1536 640v128h128v-128h-128zM1536 384v128h128v-128h-128zM1536 128v128h128v-128h-128zM1280 128v128h128v-128h-128zM1024 128v128h128 v-128h-128zM768 128v128h128v-128h-128zM512 128v128h128v-128h-128zM256 128v128h128v-128h-128zM256 1152v128h128v-128h-128zM256 1408v128h128v-128h-128zM256 1664v128h128v-128h-128zM256 1920v128h128v-128h-128zM512 1920v128h128v-128h-128zM768 1920v128h128v-128 h-128zM256 896v128h128v-128h-128zM256 640v128h128v-128h-128zM256 384v128h128v-128h-128z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/Preview.9ab9dda1.svg";
export { ForwardRef as ReactComponent };